import { S3GET } from './s3';

const getAvatar = async key => {
    console.log('key passed in', key);
    const s3Img = await S3GET(key.replace('public/', ''));
    return s3Img;
};

export default getAvatar;
